import { Button } from '@ads/components-react';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export interface NotificationCreateTemplateProps {
  readonly children: ReactNode;
}

/**
 * Layout da página de criação/edição de notificação via wizard.
 *
 * Renderiza o cabeçalho com ações e um slot de conteúdo para o wizard.
 */
export function NotificationCreateTemplate({ children }: NotificationCreateTemplateProps) {
  const { t } = useTranslation('notification');
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-xxs">
      <div className="flex justify-between">
        <PageHeader title={t('wizard.title')} subtitle={t('wizard.subtitle')} />
        <Button
          onClick={() => void navigate({ to: '/notification' })}
          hierarchy="tertiary"
          leadingIcon={ChevronLeftIcon}
        >
          {t('wizard.actions.back')}
        </Button>
      </div>
      <div className="flex flex-col gap-sm">{children}</div>
    </div>
  );
}
